import { ObjectStringMap } from 'found';
import { routes } from '../../constants';
import useRouter from '../../utils/useRouter';
import { SearchCategory } from '../SearchBar/SearchBar';

const createSearchQuery = (queryMap: ObjectStringMap, isSearchPage: boolean, locationQuery: ObjectStringMap) => {
  const query: ObjectStringMap = isSearchPage ? locationQuery : queryMap;
  // if the user sent an empty search term, we remove the term from the query
  // to avoid having an empty term in the URL and in the search request to the API
  if (queryMap.term === '') {
    delete query.term;
  } else {
    query.term = queryMap.term;
  }

  return query;
};

const useSearchQuery = () => {
  const { router, match } = useRouter();

  const isSearchPage = 
    match.location.pathname.startsWith(`/${routes.search.root}`) || 
    match.location.pathname.startsWith(`/${routes.courseCatalog.root}`);

  const pushSearchQueryToRouter = (params: ObjectStringMap, category?: SearchCategory) => {
    const pathname = category === 'Professional Development' ?
      `/${routes.courseCatalog.root}` : `/${routes.search.root}`;
    if (category === 'Professional Development') {
      params.contentType = 'course';
    }

    router.push({
      pathname,
      query: createSearchQuery(params, isSearchPage, match.location.query),
    });
  };

  return { pushSearchQueryToRouter };
};

export default useSearchQuery;
export { createSearchQuery };
